import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { t, applyAccountLanguage } from '../i18n';

const apiUrl = process.env.REACT_APP_API_URL;

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    const res = await fetch(`${apiUrl}/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });

    if (res.ok) {
      const data = await res.json();
      localStorage.setItem('token', data.token);
      // Open the app in the language saved on this account
      applyAccountLanguage(data.language);
      if (data.avatar) {
        localStorage.setItem('avatar', data.avatar);
      } else {
        localStorage.removeItem('avatar');
      }
      navigate('/');
    } else {
      alert(t('Погрешна е-пошта или лозинка'));
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 via-white to-blue-200 px-4 pt-12 pb-8">
      <div className="w-full max-w-md mx-auto bg-white rounded-xl shadow-lg p-8 space-y-6">
        {/* Logo */}
        <div className="flex justify-center">
          <img
            src="/favicon.ico" // Make sure you place this image in your `public` folder
            alt={t('Лого на апликацијата')}
            className="h-16"
          />
        </div>

        <h2 className="text-2xl font-bold text-center text-blue-700">{t('Добредојдовте назад')}</h2>

        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="block text-gray-600 mb-1">{t('Е-пошта')}</label>
            <input
              type="email"
              placeholder="you@example.com"
              className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div>
            <label className="block text-gray-600 mb-1">{t('Лозинка')}</label>
            <input
              type="password"
              placeholder="••••••••"
              className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition duration-200"
          >
            {t('Најави се')}
          </button>
        </form>
      </div>
    </div>
  );
}
